import { ApiClient } from '../../../infra';
/**
 * "Quem sou eu": o proprio usuario, o proprio perfil, a propria empresa.
 *
 * Mora na CASCA do hub, e nao em "Meus Dados". Os dois leem, mas a casca le
 * primeiro: ela pergunta o nome para o cabecalho e o papel para decidir o menu
 * antes de qualquer tela existir, e e ancestral de todas elas. Saber quem esta
 * logado e assunto dela.
 */
export class RestrictedApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new RestrictedApi(); }
    /**
     * O proprio registro profissional, ou `undefined` quando NAO HA um.
     *
     * O endpoint exige `ROLE_PROFESSIONAL`, entao um admin que nao seja tambem
     * profissional recebe 403 com a sessao inteira e valida. Traduzido para
     * "Sessão expirada" - que e o que acontecia, e o que o painel antigo tambem faz
     * - esse admin era expulso para o login logo depois de entrar, e o painel
     * ficava inacessivel para ele. `undefined` diz o que o 403 quer dizer aqui:
     * "este papel nao tem esse perfil".
     */
    async fetchCurrentProfessional() {
        return (await this.sendWhereRoleIsAtStake('/v2/professionals/me'));
    }
    /** A propria empresa, ou `undefined`. Mesmo caso: exige `ROLE_COMPANY_ADMIN`. */
    async fetchCurrentCompany(companyId) {
        const escopo = companyId ? `?companyId=${companyId}` : '';
        return (await this.sendWhereRoleIsAtStake(`/v2/companies/current${escopo}`));
    }
    /**
     * As empresas que quem esta logado ADMINISTRA.
     *
     * Uma pessoa pode administrar mais de uma desde 17/09/2026 - e e esta lista que
     * diz ao painel se ha escolha a oferecer. Vazia para o administrador geral: ele
     * nao administra empresa alguma, ele ve todas.
     */
    async fetchMyCompanies() {
        return (await this.sendWhereRoleIsAtStake('/v2/companies/mine')) ?? [];
    }
    /**
     * As empresas que quem esta logado ATENDE como profissional, com a profissao.
     *
     * O par de `/v2/companies/mine`. Duas listas e nao uma porque as perguntas sao
     * diferentes: "quais eu administro" decide o que as telas de gestao mostram,
     * "quais eu atendo" decide o que o cabecalho diz. A mesma pessoa pode administrar
     * uma empresa e atender outra, e nesse caso ela esta nas duas.
     *
     * A profissao vem por EMPRESA, e e o que o seletor do cabecalho mostra embaixo de
     * cada uma - e ali que "nutricionista aqui, preparadora fisica ali" fica visivel.
     */
    async fetchProfessionalCompanies() {
        return ((await this.sendWhereRoleIsAtStake('/v2/professionals/me/companies')) ??
            []);
    }
    /** O 403 destes dois e resposta, nao queda de sessao - ver `roleAtStake`. */
    async sendWhereRoleIsAtStake(path) {
        try {
            return await this.client.send('GET', path, undefined, undefined, { roleAtStake: true });
        }
        catch (caught) {
            if (caught?.status === 403) {
                return undefined;
            }
            throw caught;
        }
    }
    /**
     * A conta de quem esta logado, seja qual for o papel.
     *
     * `GET /v2/accounts/me` nao pede papel algum - so token vivo. E a identidade
     * de ultimo recurso quando o perfil de papel responde 403, e serve de prova de
     * que a sessao esta viva: se ELE tambem recusar, a sessao caiu de verdade (e
     * este, sem `roleAtStake`, e quem avisa).
     */
    async fetchCurrentUser() {
        return (await this.client.send('GET', '/v2/accounts/me'));
    }
    /**
     * So a aparencia da conta - a mesma `GET /v2/accounts/me`, lida como PREFERENCIA.
     *
     * Com `roleAtStake`: uma recusa aqui nao e sessao perdida. A aparencia e lida quando
     * a sessao nasce, e falhar nela nao pode tirar ninguem do painel - ele abre em Praia.
     */
    async fetchPanelTheme() {
        const account = (await this.client.send('GET', '/v2/accounts/me', undefined, undefined, {
            roleAtStake: true
        }));
        return account?.panelTheme;
    }
    /**
     * A aparencia do painel da pessoa logada - ver `domain/panel-theme.ts`.
     *
     * Rota propria, e nao o `PATCH /v2/accounts/me`: aquele exige nome e telefone, e trocar o
     * tema pelo menu do cabecalho nao deveria reenviar os dados de pessoa.
     */
    async savePanelTheme(panelTheme) {
        await this.client.send('PATCH', '/v2/accounts/me/panel-theme', { panelTheme });
    }
    /** So os campos enviados mudam (`PATCH`). */
    async updateProfessional(payload) {
        await this.client.send('PATCH', '/v2/professionals/me', payload);
    }
    /**
     * Os proprios dados de pessoa, para quem NAO tem registro profissional.
     *
     * `PATCH /v2/professionals/me` exige `ROLE_PROFESSIONAL`, entao um admin que nao
     * seja tambem profissional nao tinha onde salvar. Este endpoint nao pede papel -
     * o alvo e sempre o da sessao - e aceita so os quatro campos de pessoa: e-mail e
     * CPF ficam de fora de proposito, e o painel ja os mostra travados.
     */
    async updateCurrentUser(payload) {
        return (await this.client.send('PATCH', '/v2/accounts/me', payload));
    }
    /**
     * Troca a propria senha.
     *
     * Endpoint `PUT /v2/accounts/me/password`, que exige sessao - distinto do fluxo de
     * "esqueci a senha", que passa por codigo no e-mail.
     */
    async changePassword(currentPassword, newPassword) {
        await this.client.send('PUT', '/v2/accounts/me/password', { currentPassword, newPassword });
    }
}
//# sourceMappingURL=restricted.api.js.map